<template>
  <div class="letterEntry__header entryHeader">
    <div class="productDetail">
      <div class="card">
        <div class="productDetail__info media">
          <div class="media__image">
            <uranai-img data-clip-path-support="true" data-size="sm" size="sm" :alt="item.item_name" :src="item.pack_image"></uranai-img>
          </div>
          <div class="media__content">
            <p class="cornerName">{{ item.service_type_str }}</p>
            <h3 class="productName">{{ item.item_name }}</h3>
            <p class="counselorName">{{ item.item_theme }}</p>
          </div>
        </div>
        <div class="productDetail__price">
          <div>価格</div>
          <div class="price"><span v-price="item.price_taxin"></span>（税込）</div>
        </div>
        <div class="productDetail__price" v-if="paymentTypeStr && displayPaymentMethod">
          <div>支払い方法</div>
          <div class="price">{{ paymentTypeStr }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'

export default {
  name: 'entry-form-header-no-steps',
  props: {
    itemsId: { type: String, required: true },
    product: Object,
    step: { type: Number, default: 1 },
    confirm: { type: Boolean, default: false }
  },
  data() {
    return {
      // 決済画面以外ではお支払い方法は表示しない
      displayPaymentMethod: location.pathname.includes('payment'),
      steps: [
        { text: 'プロフィール入力' },
        { text: 'お支払い' },
        { text: '購入完了' }
      ]
    }
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      item: state => state.item.selected,
      card: state => state.payment.card
    }),
    ...mapGetters(['isLoggedIn', 'paymentTypeStr'])
  },
  mounted() {

    this.$store.dispatch(type.SELECT_ITEM, { id: parseInt(this.itemsId, 10) })
    this.getPaymentInfo()
  },
  methods: {
    getPaymentInfo() {
      if (this.isLoggedIn && this.accessToken) {
        const tokenData = { access_token: this.accessToken }
        return this.$store
          .dispatch(type.GET_PAYMENT_INFO, tokenData)
          .then(this.$store.dispatch(type.GET_PAYMENT_HISTORY, tokenData))
      }
    },
    getStep() {
      if (!this.confirm || !this.card.number) {
        return this.step
      }
      if (this.card.number) {
        return 2
      }
    }
  }
}</script>

<style scoped lang="scss">
.productDetail {
  padding: 16px;
  background: #EEF5E5;
  &__info {
    border-bottom: 1px solid #D8D8D8;
    padding-bottom: 8px;
  }
  &__price {
    height: 32px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 12px;
    .price {
      font-size: 16px;
      font-weight: bold;
      color: #8cc63f;
    }
  }
  .cornerName {
    font-size: 12px;
    margin: 0 0 4px;
    color: #E4007F;
  }
  .productName {
    font-size: 16px;
    margin: 0 0 4px;
    font-weight: bold;
    color: #141414;
  }
  .counselorName {
    font-size: 12px;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/EntryForm/EntryFormHeaderNoSteps.vue